'use strict';

/**
 * Service: HTTP
 *
 * @version
 * 2.47.0 LIBENV-219 Refactor bcxOauth2HttpRequest to support specifying $http config parameter
 * 1.30.0 LIBENV-95 Create new Oauth2HttpService to handle native http responses
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Deitric Jang <djang@buildcentrix.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
angular.module('bcx.service.http', ['wd.handler.response.api'])
    .factory('bcxHttpService',
        ['$http',
            function ($http) {

                var service = {};
                var headers = {};

                /**
                 * Process Request
                 * Process a request based upon the result data structure and status code.
                 *
                 * @since 2.47.0
                 * @param {Object} request
                 * @param {Object} cacheOptions
                 * @param {Object} config $http config options
                 * @returns {Object}
                 */
                service.processHttpRequest = function(request, cacheOptions, config) {

                    // Setup default caching options
                    if (!cacheOptions) {
                        // set up timestamp for anti-caching
                        // @see https://github.com/webduct/order-admin-ui/issues/207 // see http://stackoverflow.com/a/33131028/1304537
                        var $timestamp = new Date / 1E3 | 0; // jshint ignore:line

                        cacheOptions = {
                            appendHashToUrl: true,
                            hash: $timestamp
                        };

                    }

                    request.headers = headers;

                    if (cacheOptions.appendHashToUrl) {
                        if (cacheOptions.hash) {
                            request.url += (request.url.split('?')[1] ? '&' : '?') + cacheOptions.hash;  //http://stackoverflow.com/a/4811158/4355129
                        }
                    }

                    var httpConfig = config ? config : {withCredentials: true};

                    return $http(request, httpConfig);

                };

                /**
                 * Add Header to request
                 *
                 * @since 1.30.0
                 * @param {String} headerName
                 * @param {String} headerValue
                 * @returns {Boolean}
                 */
                service.addHeader = function (headerName, headerValue) {

                    var result = false;

                    if (typeof headers[headerName] === 'undefined') {
                        headers[headerName] = headerValue;
                        result = true;
                    }

                    return result;
                };

                /**
                 * Delete Header from request
                 *
                 * @since 1.30.0
                 * @param {String} headerName
                 * @returns {Boolean}
                 */
                service.deleteHeader = function (headerName) {
                    var result = false;

                    if (headers.hasOwnProperty('' + headerName + '')) {
                        delete headers[headerName];
                        result = true;
                    }

                    return result;
                };

                /**
                 * Update existing header
                 *
                 * @since 1.30.0
                 * @param {String} headerName
                 * @param {String} headerValue
                 * @returns {Boolean}
                 */
                service.updateHeader = function (headerName, headerValue) {
                    var result = false;

                    if (headers.hasOwnProperty('' + headerName + '')) {
                        headers[headerName] = headerValue;
                        result = true;
                    }

                    return result;
                };

                /**
                 * GET wrapper
                 *
                 * @since 1.30.0
                 * @returns {Object}
                 */
                service.get = function (url) {

                    return service.processHttpRequest({ method: 'GET', url: url }, null);

                };

                /**
                 * POST wrapper
                 *
                 * @since 1.30.0
                 * @returns {Object}
                 */
                service.post = function (url, data) {

                    return service.processHttpRequest({ method: 'POST', url: url, data: data }, null);

                };

                /**
                 * PUT wrapper
                 *
                 * @since 1.30.0
                 * @returns {Object}
                 */
                service.put = function (url, data) {

                    return service.processHttpRequest({ method: 'PUT', url: url, data: data }, null);

                };

                return service;

            }]);

// EOF